export default __webpack_public_path__ + "static/double-event-place-holder-image-115d4994f423c8c388fa83b1bed28089.jpg";